import { groupBy, sortBy, values } from "lodash";
import { barchartDataMock, barchartOptions, linechartMock, linechartMock2, linechartOptionsMock } from "../mock/chartJS.mock";
import { getRandomColorByChannel } from "./colors.utils";
import { DateUtil } from "./date.util";

//1. Remove all EMPTY "payment_channel"
//export const transactionsWithoutEmptyPaymentChannels = (data) => data.filter((transaction) => transaction.payment_channel);
export const transactionsWithoutEmptyPaymentChannels = (data) => data.filter((transaction) => transaction.paymentChannel);

export const sortTransactionDataByDate = (data) => sortBy(data, (item) => item.date);

export const groupTransactionDataByDate = (data) => values(groupBy(data, "date"));

// --------------------------------------------------------
// TOTALS by Payment Channels
// example output for COUNT: {cash: 250, Twint: 33, Apple/Google pay: 9, Credit card: 3}
// example output for AMOUNT: {cash: 2069.3999999999983, Twint: 246.45000000000005, Apple/Google pay: 85.9, Credit card: 60.25}
// --------------------------------------------------------
export const totalPaymentChannelsCountNew = (transactions) =>
  transactions.reduce((accumulator, currentValue) => {
    const paymentChannel = currentValue["paymentChannel"];
    if (paymentChannel in accumulator) {
      accumulator[paymentChannel] += 1;
    } else {
      accumulator[paymentChannel] = 1;
    }
    return accumulator;
  }, {});

export const totalPaymentChannelsAmountNew = (transactions) =>
  transactions.reduce((accumulator, currentValue) => {
    const paymentChannel = currentValue["paymentChannel"];
    if (paymentChannel in accumulator) {
      accumulator[paymentChannel] += currentValue.price;
    } else {
      accumulator[paymentChannel] = currentValue.price;
    }
    return accumulator;
  }, {});

// --------------------------------------------------------
// COUNT & AMOUT by Payment Channels PER DATE
// example output for COUNT: [{date: '2022.11.29', "": 1, Twint: 6, Apple/Google pay: 1, cash: 3}, ...]
// example output for AMOUNT: [{date: '2022.11.27', Twint: 9.25, cash: 7.5}, ...]
// --------------------------------------------------------
export const countPaymentChannelsByDate = (transactions = []) => {
  const counts = {};
  transactions.forEach((transaction) => {
    const { paymentChannel, date } = transaction;
    if (!counts[date]) {
      counts[date] = {};
    }
    if (!counts[date][paymentChannel]) {
      counts[date][paymentChannel] = 0;
    }
    counts[date][paymentChannel] += 1;
  });
  return Object.entries(counts).map(([date, channels]) => ({
    date,
    ...channels,
  }));
};

export const sumPaymantChannelsAmountByDate = (transactions = []) => {
  const counts = {};
  transactions.forEach((transaction) => {
    const { paymentChannel, date, price } = transaction;
    if (!counts[date]) {
      counts[date] = {};
    }
    if (!counts[date][paymentChannel]) {
      counts[date][paymentChannel] = 0;
    }
    // AMOUNT * COUNT (Price * Count)
    //counts[date][payment_channel] += price * count;
    counts[date][paymentChannel] += price;
  });

  return Object.entries(counts).map(([date, channels]) => ({
    date,
    ...channels,
  }));
};

// --------------------------------------------------------
// COUNT & AMOUT by DATE
// example output for COUNT & AMOUT: [{date: '2022.11.21', count: 2, amount: 16.1}, ...]
// --------------------------------------------------------
export const countAndAmountFromGroupedDates = (transactions = []) => {
  const groupByDate = groupTransactionDataByDate(transactions);

  const countAmountDate = groupByDate.map((dateItem) => {
    const countSum = dateItem.length;
    const amountSum = dateItem.map((item) => item.price).reduce((sum, val) => sum + val, 0);
    const dateValue = dateItem[0].date;
    return { date: dateValue, count: countSum, amount: amountSum };
  });

  return countAmountDate;
};

// --------------------------------------------------------
//
// COUNT & AMOUT & TOTAL by DATE
// example output for COUNT & AMOUT: [{date: '2022.11.21', count: 2, amount: 16.1, total: 540 }, ...]
// --------------------------------------------------------
export const countAmountTotalFromGroupedDates = (transactions = [], alreadyGroupedFlag = false) => {
  const groupByDate = alreadyGroupedFlag ? transactions : groupTransactionDataByDate(transactions);

  const countAmountTotalDate = groupByDate.map((dateItem) => {
    const countSum = dateItem.map((item) => item).reduce((sum, val) => sum + 1, 0);
    const amountSum = dateItem.map((item) => item.price).reduce((sum, val) => sum + val, 0);
    const totalAmount = dateItem.map((item) => item.price).reduce((sum, val) => sum + val, 0);
    const dateValue = dateItem[0].date;
    return { date: dateValue, count: countSum, amount: amountSum, total: totalAmount };
  });

  return countAmountTotalDate;
};

// --------------------------------------------------------
// COUNT & AMOUT by Payment Channels PER DAY OF THE WEEK
// example output for COUNT: [{date: '2022.11.29', "": 1, Twint: 6, Apple/Google pay: 1, cash: 3}, ...]
// example output for AMOUNT: [{date: '2022.11.27', Twint: 9.25, cash: 7.5}, ...]
// --------------------------------------------------------
export const totalPaymantChannelsAmountAndCountByDayOfTheWeek = (transactions = []) => {
  const groupByDay = DateUtil.sortToCorrectWeekDays(transactions);

  const dayNamesArray = groupByDay.map((transactionGroup) => transactionGroup.day);

  //Barchart by amount per day
  const amountByDayOfTheWeek = groupByDay.map((val) => {
    const transactionsArray = val.transactions;
    const priceByPaymentChannel = transactionsArray.reduce((accumulator, currentValue) => {
      const paymentChannel = currentValue["paymentChannel"];
      if (paymentChannel in accumulator) {
        accumulator[paymentChannel] += currentValue.price;
      } else {
        accumulator[paymentChannel] = currentValue.price;
      }
      //console.log("BAR CHART 1 => ",val, transactionsArray,currentValue, accumulator)
      return accumulator;
    }, {});
    return priceByPaymentChannel;
  });

  const countByDayOfTheWeek = groupByDay.map((val) => {
    const transactionsArray = val.transactions;

    const countByPaymentChannel = transactionsArray.reduce((accumulator, currentValue) => {
      const paymentChannel = currentValue["paymentChannel"];
      if (paymentChannel in accumulator) {
        accumulator[paymentChannel] += 1;
      } else {
        accumulator[paymentChannel] = 1;
      }
      return accumulator;
    }, {});

    return countByPaymentChannel;
  });

  return { amountByDayOfTheWeek, countByDayOfTheWeek, dayNamesArray };
};

export const calculateAllTransactionsCardData = (data) => {
  //1. GROUP ALL BY DAYS
  const groupedTransactionsByDate = groupTransactionDataByDate(data);

  //2. DATE RANGE IN DAYS
  const days = groupedTransactionsByDate.length;

  //3. COUNT TRANSACTIONS NUM IN EACH DAY

  const countByDate = countAmountTotalFromGroupedDates(groupedTransactionsByDate, true);

  //console.log("TRNASCTIONS CALC =============> ", { countByDate, groupedTransactionsByDate , days });

  //4. CALCULATE ALL CARDS DATA
  const totalTransactions = countByDate.reduce((sum, val) => sum + val.count, 0); //COUNT TOTAL SUM
  const totalAmountPrices = countByDate.reduce((sum, val) => sum + val.total, 0); //UPDATE AMOUNT * COUNT
  const averageAmountPrices = (totalAmountPrices / days || 0).toFixed(2);
  const averageNumberTransactions = (totalTransactions / days || 0).toFixed(2);
  const averageAmountPerTrans = (averageAmountPrices / averageNumberTransactions || 0).toFixed(2);

  return {
    //groupByDate,
    averageAmountPerTrans,
    averageAmountPrices,
    averageNumberTransactions,
    countByDate,
    numberOfDays: days,
    totalAmountPrices,
    totalTransactions,
  };
};

export const getGraphData = (data, uniquePaymentChannels, startDate, endDate, translateFunc) => {
  //const vendingDataFiltered = transactionsWithoutEmptyPaymentChannels(data) || [];
  const vendingData = data;
  
  const { amountByDayOfTheWeek, countByDayOfTheWeek, dayNamesArray } = totalPaymantChannelsAmountAndCountByDayOfTheWeek(vendingData);

  // --------------------------------------------------------
  // LINE CHARTS - Count/Amount by Payment Channels
  // --------------------------------------------------------
  const countAndAmountByDate = countAndAmountFromGroupedDates(vendingData);
  const filledData1 = DateUtil.fillMissingAmountCountDatesWithZeros(startDate, endDate, countAndAmountByDate);

  //LINE CHART BY AMOUNT
  //BY DAY
  const amountByDayLinechartData = {
    linechartData: {
      ...linechartMock,
      labels: DateUtil.addOneMoreDay(filledData1),
      datasets: [
        {
          ...linechartMock.datasets[1],
          data: filledData1.map((item) => item.amount),
          label: translateFunc("refactored:graphs.linechart.amount.amountDaily.label"), //"Transaction Amount per Day",
        },
      ],
    },
    linechartOptions: { ...linechartOptionsMock },
  };
  //BY PAYMENT METHOD
  const amountByDate = sumPaymantChannelsAmountByDate(vendingData);

  const filledData3 = DateUtil.fillMissingDatesWithZeros(startDate, endDate, amountByDate, uniquePaymentChannels);

  const transactionsByCount = uniquePaymentChannels.map((channel) => {
    return {
      label: channel,
      data: filledData3?.map((item) => item[channel]), //amountByDate.map((item) => item[channel]),
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: getRandomColorByChannel(channel),
      pointBackgroundColor: "ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.4,
    };
  });

  const amountByChannelsLinechartData = {
    linechartData: {
      ...linechartMock2,
      labels: DateUtil.addOneMoreDay(filledData3), //countByDayLabels,
      datasets: transactionsByCount,
    },
    linechartOptions: { ...linechartOptionsMock },
  };

  const countByDayLinechartData = {
    linechartData: {
      ...linechartMock,
      labels: DateUtil.addOneMoreDay(filledData1),
      datasets: [
        {
          ...linechartMock.datasets[0],
          data: filledData1.map((item) => item.count),
          label: translateFunc("refactored:graphs.linechart.count.countDaily.label"), //"Transaction Count per Day",
        },
      ],
    },
    linechartOptions: { ...linechartOptionsMock },
  };

  //BY PAYMENT METHOD
  const countByDate2 = countPaymentChannelsByDate(vendingData);

  const filledData2 = DateUtil.fillMissingDatesWithZeros(startDate, endDate, countByDate2, uniquePaymentChannels);

  const countByChannelsDataset = uniquePaymentChannels.map((channel) => {
    return {
      label: channel,
      data: filledData2.map((item) => item[channel] || 0), //countByDate2
      borderWidth: 3,
      backgroundColor: "transparent",
      borderColor: getRandomColorByChannel(channel),
      pointBackgroundColor: "ffffff",
      pointRadius: 0,
      type: "line",
      tension: 0.4,
    };
  });

  //Create FULL LINE CHART 1 DATA
  const countByChannelsLinechartData = {
    linechartData: {
      ...linechartMock2,
      labels: DateUtil.addOneMoreDay(filledData2),
      datasets: countByChannelsDataset,
    },
    linechartOptions: { ...linechartOptionsMock },
  };

  // --------------------------------------------------------
  // BAR CHARTS - Count/Amount by Payment Channels
  // --------------------------------------------------------
  // BARCHART BY AMOUNT
  const channelsForWeek1 = [...new Set(amountByDayOfTheWeek.flatMap((obj) => Object.keys(obj)))];
  const barchart1Labels = dayNamesArray;
  const barchart1Dataset = channelsForWeek1.map((channel, index) => {
    const weekDataForChannel = amountByDayOfTheWeek.map((data) => data[channel]);
    const stackValue = index + 1; // Get the total number of keys (elements) in the object

    return {
      label: channel,
      data: weekDataForChannel,
      backgroundColor: getRandomColorByChannel(channel),
      stack: "Stack " + stackValue,
    };
  });

  //console.log("BAR CHART DATA => ", barchart1Labels, barchart1Dataset, channelsForWeek1);
  const barchartAmountByDayData = {
    labels: barchart1Labels,
    datasets: barchart1Dataset,
  };

  const amountsByDayOfWeekByPaymentMethodBarChartJsData = {
    options: barchartOptions,
    data: barchartAmountByDayData,
  };

  //BY COUNT
  const channelsForWeek2 = [...new Set(countByDayOfTheWeek.flatMap((obj) => Object.keys(obj)))];

  const barchart2Labels = dayNamesArray;
  const barchart2Dataset = channelsForWeek2.map((channel, index) => {
    const weekDataForChannel = countByDayOfTheWeek.map((data) => data[channel]);
    const stackValue = index + 1; // Get the total number of keys (elements) in the object

    return {
      label: channel,
      data: weekDataForChannel,
      backgroundColor: getRandomColorByChannel(channel),
      stack: "Stack " + stackValue,
    };
  });

  const barchartCountByDayData = {
    labels: barchart2Labels,
    datasets: barchart2Dataset,
  };

  const countsByDayOfWeekByPaymentMethodBarChartJsData = {
    options: barchartOptions,
    data: barchartCountByDayData,
  };

  // ---------------------------------------
  // PIE CHART
  // ---------------------------------------
  //AMOUNT BY OPERATOR TOTAL
  //CALCULATING ALL AMOUNTS PER OPERATOR
  const priceByPaymentChannel = totalPaymentChannelsAmountNew(vendingData);

  //amounts for graph
  const totalAmountsPerPaymentChannels = Object.entries(priceByPaymentChannel).map(([label, value]) =>
    value !== null ? parseFloat(value.toFixed(2)) : 0
  );
  //Label for graph
  const labelsForPieChart = Object.entries(priceByPaymentChannel).map(([label, value]) => label);

  const totalAmountsByOperatorPieChartJSData = {
    labels: labelsForPieChart, //["Twint", "Credit Card" ...]
    datasets: [
      {
        data: totalAmountsPerPaymentChannels, //[300, 50, 100],
        backgroundColor: labelsForPieChart.map((name) => getRandomColorByChannel(name)),
        label: "CHF",
      },
    ],
    hoverOffset: 4,
  };

  // ---------------------------------------
  // DOUGHNUT CHART
  // ---------------------------------------
  //1. Count all "payment_channel"
  const countByPaymentChannels = totalPaymentChannelsCountNew(vendingData);

  //Total transaction COUNT per operator
  const totalCountByPaymentChannels = Object.entries(countByPaymentChannels).map(([label, value]) => parseFloat(value.toFixed(2)));

  const totalCount = Object.values(countByPaymentChannels).reduce((acc, current) => acc + current, 0);
  const totalPercentageByPaymentChannels = Object.entries(countByPaymentChannels).map(([label, value]) =>
    parseFloat(((value / totalCount) * 100).toFixed(2))
  );

  const lobalForFoughnutCharts = Object.entries(countByPaymentChannels).map(([label, value]) => label);

  //DOUGHNUT
  const totalAmountAndPercentageByPaymentChannelsPieChartJsData = {
    labels: lobalForFoughnutCharts,
    datasets: [
      {
        data: totalCountByPaymentChannels, //[300, 50, 100],
        backgroundColor: lobalForFoughnutCharts.map((name) => getRandomColorByChannel(name)),
        label: `Total`,
        position: "left",
      },
      {
        data: totalPercentageByPaymentChannels, //[300, 50, 100],
        backgroundColor: lobalForFoughnutCharts.map((name) => getRandomColorByChannel(name)),
        label: "%",
        position: "top",
      },
    ],
    hoverOffset: 4,
  };

  return {
    // LINE CHARTS
    amountByDayLinechartData,
    countByDayLinechartData,
    amountByChannelsLinechartData,
    countByChannelsLinechartData,

    // PIE CHARTS
    totalAmountsByOperatorPieChartJSData,
    totalAmountAndPercentageByPaymentChannelsPieChartJsData,

    //BAR CHART
    amountsByDayOfWeekByPaymentMethodBarChartJsData,
    countsByDayOfWeekByPaymentMethodBarChartJsData,
  };
};
